<!--todo 非单向数据流-->
<template>
  <div
    style="width: 200px"
    v-loading="isLoading"
  >
    <div
      v-if="value.row.budget_amount"
      class="h-[80px]"
    >
      <div v-if="!isEditing">
        {{ formatedMoney(value.row, 'budget_amount') }}
        <i
          class="el-icon-edit-outline"
          style="cursor: pointer"
          @click="beforeEditBuget(true)"
          v-if="value.row.effective_status != 'ARCHIVED' && value.row.effective_status != 'DELETED'"
        ></i>
      </div>
      <div v-if="isEditing">
        <el-form
          :model="formData"
          ref="budgetForm"
          :rules="rules"
        >
          <el-form-item prop="editValue">
            <el-input
              size="small"
              v-model="formData.editValue"
              v-cell-focus
              @blur="cancelEditBuget"
              @change="editBudget(true)"
            >
            </el-input>
          </el-form-item>
        </el-form>
      </div>
      <span class="color9">{{ budgetTypes.find((v) => v.value == value.row.budget_type).label }}</span>
      <br />
      <el-tag
        v-if="value.row.status === 'ENABLED'"
        size="mini"
        style="cursor: pointer"
        @click="setTimeEditBudgetHandle()"
        >定时改预算</el-tag
      >
    </div>
    <set-time-edit-budget
      ref="setTimeEditBudget"
      :row="rowWithThirdNum"
      :level="'campaign'"
      platform="google"
      :needDec100="false"
      :gimpUserId="userInfo.data.id"
      @settingComplete="handleSettingComplete"
    />
  </div>
</template>

<script>
import { cmpaignBudget } from '@/api/google/account.js';
import { mapGetters, mapState } from 'vuex';
import { budgetTypes } from '@/views/google/create/index';
import { setTimeEditBudget } from '@adCommonComponent';
import { guardOwner } from '@/utils/ownerGuard';
export default {
  name: 'AdCellInlineEditBudget',
  components: {
    setTimeEditBudget,
  },
  props: {
    value: {
      type: Object,
    },
    dateRange: {
      type: Object,
      default: () => {},
    },
    accountId: {
      type: [String, Array],
      default: '',
    },
  },
  data() {
    return {
      editBuygetTypeShow: false,
      is_cob: false,
      oldVal: '',
      isEditing: false,
      editValue: '',
      isLoading: false,
      budgetTypes,
      formData: {
        editValue: '',
      },
      rules: {
        editValue: [
          { required: true, message: '请输入预算金额', trigger: ['blur', 'change'] },
          { validator: this.validateBudget, trigger: ['blur', 'change'] },
        ],
      },
    };
  },
  computed: {
    ...mapGetters(['toFormatedMoney']),
    ...mapState('user', ['userInfo']),
    type() {
      return this.value.row.campaign_type || this.value.row.type;
    },
    row() {
      // 为子组件准备的数据结构 - 转换为子组件需要的格式
      const scheduleData = this.value.row.open_schedule;
      return {
        ...this.value.row,
        campaignId: this.value.row.id,
        adAccountId: Array.isArray(this.accountId) ? this.accountId[0] : null,
        hasSchedule: scheduleData?.hasSchedule || false,
        open_schedule: scheduleData?.schedules || [], // 直接传递schedules数组1
      };
    },
    rowWithThirdNum() {
      return {
        ...this.row,
        rowThirdNum: this.value.row.rowThirdNum,
      };
    },
  },
  created() {},
  methods: {
    refreshTableRow() {
      const regex = /^\d*(\.\d{0,2})?$/;
      if (regex.test(this.editValue) || this.editValue === '') {
        // Valid input
      } else {
        this.editValue = this.editValue.slice(0, -1);
      }
      this.$emit('scope-row-changed', this.value);
    },
    refreshTable() {
      this.$emit('get-list');
    },
    cancelEditBuget() {
      console.log(this.editValue == this.value.row.budget_amount, this.editValue, this.value.row.budget_amount);
      if (this.editValue == this.value.row.budget_amount) {
        this.isEditing = false;
        this.refreshTableRow();
      }
    },
    formatedMoney(v, type) {
      const currencySign = v.currency || '$';
      if (!v[type]) return '';
      return currencySign + parseFloat(v[type]).toFixed(2);
    },
    async beforeEditBuget(isDaily) {
      if (!(await guardOwner(this.value.row))) return;
      let val = parseFloat(this.value.row.budget_amount);
      this.oldVal = val;
      this.editValue = val;
      this.formData.editValue = val;
      this.isEditing = true;
    },
    calculateDaysDifference(startDate, endDate) {
      // 将字符串日期转换为 Date 对象
      const start = new Date(startDate);
      const end = new Date(endDate);

      // 确保日期是有效的
      if (isNaN(start.getTime()) || isNaN(end.getTime())) {
        throw new Error('Invalid date format');
      }

      // 计算两个日期之间的时间差（以毫秒为单位）
      const differenceInMilliseconds = end - start;

      // 将时间差转换为天数
      // 注意：这里加1是因为包括起始日
      const differenceInDays = Math.floor(differenceInMilliseconds / (1000 * 60 * 60 * 24)) + 1;

      return differenceInDays;
    },
    editBudget(isDaily) {
      this.$refs.budgetForm.validate((valid) => {
        if (!valid) return;

        let scope = this.value;
        let row = scope.row;
        let targetVal = this.formData.editValue;
        // 总预算：系列生效期间平均每天预算不能小于5
        if (!isDaily && row.level === 'campaign') {
          const days = this.calculateDaysDifference(row.start_date, row.end_date);
          if (Number(targetVal) < 5 * days) {
            this.$message.warning(`平均每天预算不能小于5,推荐设置${5 * days}以上的数值`);
            return;
          }
        }

        // 检查预算增幅是否大于等于10倍，需要二次确认
        const newVal = parseFloat(targetVal);
        const oldVal = parseFloat(this.oldVal);
        if (oldVal > 0 && newVal >= oldVal * 10) {
          this.$confirm(`预算从 ${oldVal} 修改为 ${newVal}，增幅较大，请确认`, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
            .then(() => {
              this.submitBudget(isDaily, row, targetVal);
            })
            .catch(() => {
              this.isEditing = false;
              this.formData.editValue = this.oldVal;
              this.refreshTableRow();
            });
        } else {
          this.submitBudget(isDaily, row, targetVal);
        }
      });
    },
    submitBudget(isDaily, row, targetVal) {
      let params = {
        customerId: this.accountId.toString(),
        campaignBudgetResourceNames: [row.budget_resource_name],
        campaignDailyBudget: isDaily ? targetVal : null,
        campaignLifetimeBudget: isDaily ? null : targetVal,
        resourceNames: [row.resource_name],
        oldVal: this.oldVal,
      };
      this.isLoading = true;
      cmpaignBudget(params)
        .then((res) => {
          this.isLoading = false;
          this.isEditing = false;
          if (res.code == 0) {
            row.budget_amount = targetVal;
            this.editValue = targetVal;
          } else {
            this.$message({
              type: 'warning',
              message: '失败了',
            });
          }
          this.refreshTableRow();
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    validateBudget(rule, value, callback) {
      if (!value) {
        callback(new Error('请输入预算金额'));
        return;
      }

      const numValue = parseFloat(value);
      if (this.type == 'DEMAND_GEN' && numValue < 5) {
        callback(new Error('预算金额不能小于5'));
        return;
      }

      const decimalRegex = /^\d+(\.\d{1,2})?$/;
      if (!decimalRegex.test(value.toString())) {
        callback(new Error('请输入正确的金额格式，最多两位小数'));
        return;
      }

      callback();
    },
    transBudget(v) {
      console.log(v);
      this.is_cbo = v;
      this.editBuygetTypeShow = true;
      this.$forceUpdate();
    },
    // 定时改预算
    async setTimeEditBudgetHandle() {
      if (!(await guardOwner(this.value.row))) return;
      this.$refs.setTimeEditBudget.dialogVisible = true;
    },
    handleSettingComplete(formData, type, id, budgetAmount, taskId, data) {
      // rowWithThirdNum 是新对象，底层组件 push 不到原始数据
      // 需要手动同步到 value.row.open_schedule
      if (!this.value.row.open_schedule) {
        this.$set(this.value.row, 'open_schedule', {
          schedules: [],
          hasSchedule: false,
        });
      }
      // 检查是否已被底层组件 push 过（schedules 引用可能相同时会重复）
      const alreadyAdded = this.value.row.open_schedule.schedules.some(
        (s) => s.type === 2 && s.timeStr === formData.dateVal && (s.id === taskId || s.id === data?.id),
      );
      if (!alreadyAdded) {
        const scheduleData = {
          id: taskId,
          adId: id,
          timeStr: formData.dateVal,
          budget: budgetAmount,
          lifetimeBudget: this.value.row.budget_type === 'LIFETIME' ? budgetAmount : null,
          dailyBudget: this.value.row.budget_type === 'DAILY' ? budgetAmount : null,
          type: 2,
          ...data,
        };
        this.value.row.open_schedule.schedules.push(scheduleData);
      }
      this.value.row.open_schedule.hasSchedule = true;
    },
  },
  directives: {
    'cell-focus': {
      bind(el, binding) {
        // el.focus();
        setTimeout(() => {
          el.children[0].focus();
        }, 200);
      },
    },
  },
};
</script>

<style scoped lang="scss">
.el-input {
  width: 80%;
}
:deep(.el-form-item) {
  margin-bottom: 0;
}
// 定时改预算弹窗中的表单项需要间距
:deep(.budgetDialog .el-form-item) {
  margin-bottom: 21px !important;
}
</style>
